import script from "./BadgeCurs.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeCurs.vue?vue&type=script&setup=true&lang=js"

import "./BadgeCurs.vue?vue&type=style&index=0&id=5d27a591&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d27a591"]])

export default __exports__